import { Controller } from '@hotwired/stimulus';

// Drag-and-drop / click-to-browse uploader for brand reference images.
// Submits the surrounding form (standard multipart POST) once files are
// chosen, showing an uploading state on the dropzone.
export default class extends Controller {
  static targets = ['input', 'zone', 'label'];

  connect() {
    this.defaultLabel = this.hasLabelTarget ? this.labelTarget.innerHTML : '';
  }

  choose(event) {
    // The hidden input lives inside the clickable zone — ignore the bubbled
    // event from our own programmatic click to avoid recursion.
    if (event.target === this.inputTarget) return;
    event.preventDefault();
    this.inputTarget.click();
  }

  filesChosen() {
    if (this.inputTarget.files.length > 0) this.submit();
  }

  dragOver(event) {
    event.preventDefault();
    this.zoneTarget.classList.add('brand-dropzone-active');
  }

  dragLeave(event) {
    event.preventDefault();
    this.zoneTarget.classList.remove('brand-dropzone-active');
  }

  drop(event) {
    event.preventDefault();
    this.zoneTarget.classList.remove('brand-dropzone-active');

    const images = Array.from(event.dataTransfer.files).filter((f) =>
      f.type.startsWith('image/')
    );
    if (images.length === 0) return;

    const transfer = new DataTransfer();
    images.forEach((f) => transfer.items.add(f));
    this.inputTarget.files = transfer.files;
    this.submit();
  }

  submit() {
    const count = this.inputTarget.files.length;
    if (this.hasLabelTarget) {
      this.labelTarget.innerHTML = `Uploading ${count} ${count === 1 ? 'image' : 'images'}&hellip;`;
    }
    this.zoneTarget.classList.add('brand-dropzone-uploading');
    this.element.closest('form').submit();
  }
}
